/* eslint-disable no-unused-vars */
import React from "react";
import { Title } from "../components/styles";
import {
  AuthPageBanner,
  AuthPageContainer,
  FormLink,
  Form,
  FormContainer,
  Input,
  InputContainer,
  Label,
  FormFooter,
  FooterText,
  Desc,
  FormLeftContainer,
} from "../components/Generals/LoginStyles";
import Filledbutton from "../components/Reusables/Buttons/Filledbutton";
import { useNavigate } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "../Redux/app/hooks";
import { errorMessage, getFormDetails } from "../Redux/Reducers/formReducer";
import { validateemail } from "../Helpers/generals";
import { ResetUserPassword } from "../Apis/accountProcesing";

const ResetPassword = () => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const { email, error, loading } = useAppSelector((state) => state.form);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    e.preventDefault();
    dispatch(errorMessage(""));
    const { name, value } = e.target;
    dispatch(getFormDetails({ name, value }));
  };

  const handleSubmit = (e: React.ChangeEvent<HTMLInputElement>) => {
    e.preventDefault();
    if (!email || !validateemail(email)) {
      dispatch(errorMessage("Please fill in a valid email"));
    } else {
      ResetUserPassword(email, navigate);
    }
  };

  return (
    <AuthPageContainer>
      <FormLeftContainer href="https://switchwallet.io">
        <AuthPageBanner src="/assets/images/Forms/Login-banner.png" />
      </FormLeftContainer>
      <FormContainer>
        <Form>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              marginBottom: "30px",
            }}
          >
            <Title>Reset Password</Title>
            <Desc>
              Enter your email address and we will send you an email with
              instructions to reset your password.
            </Desc>
          </div>
          <InputContainer>
            <Label>Email</Label>
            <Input
              type="email"
              placeholder="Enter email"
              onChange={handleChange}
              name="email"
            />
          </InputContainer>
          <Filledbutton
            text="Reset"
            handleClick={handleSubmit}
            loading={loading}
          />

          <FormFooter>
            <FooterText>Already have an account?</FooterText>
            <FormLink to="/">Login</FormLink>
          </FormFooter>
          <div style={{ marginTop: "20px" }} className="text-red">
            {error}
          </div>
        </Form>
      </FormContainer>
    </AuthPageContainer>
  );
};

export default ResetPassword;
